import React, {useState} from 'react';
import '../../../css/style.scss'
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {NavLink} from "react-router-dom";
import Link from "@material-ui/core/Link";
import {themeButtons} from "../../../css/themeButtons";
import {useUserVerified} from "../../../App";

const Access2Object = ({formRef, getAccess2ObjectAuth, onSuccess}) => {
    let [saving, setSaving] = useState(false)
    const useVerified = useUserVerified();
    const loginSchema = Yup.object().shape({
        name: Yup.string()
            .required('Поле не заполнено')
            .min(3, 'Укажите полное название объекта'),
        address: Yup.string()
            .required('Поле не заполнено')
            .min(5, 'Укажите полный адрес объекта размещения'),
    }, [['name', 'address']]);


    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const onSubmit = async values => {
        let res = await getAccess2ObjectAuth(values);
        if (res) {
            setSaving(true)
            await sleep(3000);
            onSuccess(false);
            setSaving(false)
        }
    };
    const buttons = themeButtons();
    if (useVerified == 'Y')
    {
        return (<>
            <Formik validationSchema={loginSchema} innerRef={formRef}
                    initialValues={{
                        name: '',
                        address: '',
                        link: ''
                    }}
                    onSubmit={onSubmit}>
                {({errors, touched, handleSubmit, isSubmitting}) => (
                    <Form>
                        {!saving && <><Field name="name">
                            {({field, form}) => (
                                <TextField size="small"
                                           {...field}
                                           type="text" variant="outlined"
                                           className="w-100 mb-3"
                                           required={true}
                                           label="Название объекта"
                                           error={Boolean(errors.name && touched.name)}
                                           helperText={
                                               touched.name && errors.name
                                           }
                                />
                            )}
                        </Field>
                        <Field name="address">
                            {({field, form}) => (
                                <TextField size="small"
                                           {...field}
                                           type="text" variant="outlined"
                                           className="w-100 mb-3"
                                           required={true}
                                           label="Адрес объекта"
                                           error={Boolean(errors.address && touched.address)}
                                           helperText={
                                               touched.address && errors.address
                                           }
                                />
                            )}
                        </Field>
                        <Field name="link">
                            {({field, form}) => (
                                <TextField size="small"
                                           {...field}
                                           type="text" variant="outlined"
                                           className="w-100 mb-3"
                                           label="Ссылка на сайте Едем-в-Гости.ру"
                                           error={Boolean(errors.link && touched.link)}
                                           helperText={
                                               touched.link && errors.link
                                           }
                                />
                            )}
                        </Field>

                        <Typography variant="body2" display="block" color="error">
                            Обязательно укажите название и адрес Вашего объекта, чтобы мы смогли оперативно предоставить доступ
                        </Typography>
                        </>}

                        {saving && <div className="alert alert-success">Запрос на получение доступа к объекту успешно отправлен!</div>}
                    </Form>
                )}
            </Formik>
            </>
        )
    }
    return <Typography variant="subtitle1">
        <div className="mb-3 alert alert-danger">
            Ваш аккаунт ещё не подтвержден<br/>
            Для получения доступа к объекту, пожалуйста, подтвердите регистрацию на странице Вашего профиля<br/>
        </div>
        <Link component={NavLink} className={`btn ${buttons.btnGreen} ms-auto d-block`} to={`/lk/profile`}>Подтвердить регистрацию</Link>
    </Typography>
};


export default Access2Object;